import axios from 'axios'
import { API_BASE_URL } from '@/config'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  list() {
    return api.get('/company-templates')
  },
  get(id) {
    return api.get(`/company-templates/${id}`)
  },
  save(data) {
    return api.post('/company-templates', data)
  },
  update(id, data) {
    return api.request({ method: 'put', url: `/company-templates/${id}`, data })
  },
  delete(id) {
    return api.delete(`/company-templates/${id}`)
  }
}
